import React, { useEffect } from "react";

export function ExternalLegalRedirect({
  label,
  url,
}: {
  label: string;
  url: string;
}) {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);

  return (
    <div className="page-section">
      <div className="container empty-state">
        <h1>Opening {label}</h1>
        <p>
          <a className="text-link" href={url}>
            Continue to asanowharton.com
          </a>
        </p>
      </div>
    </div>
  );
}
